module.exports = __webpack_public_path__ + "img/user-only.a33d455b.svg";